import React, { useState } from 'react';
import { FileText, Shield, CreditCard, Users, AlertCircle, Calendar, Lock, MessageSquare } from 'lucide-react';

export const Termino = () => {
  const [activeSection, setActiveSection] = useState(null);

  const sections = [
    {
      id: 'aceptacion',
      title: '1. Aceptación de los Términos',
      icon: FileText,
      content: `Al acceder y utilizar TITANIA, usted acepta estar legalmente vinculado por estos Términos de Servicio. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestros servicios. Estos términos constituyen un acuerdo legal entre usted (el "Usuario" o "Suscriptor") y TITANIA.`
    },
    {
      id: 'descripcion',
      title: '2. Descripción del Servicio',
      icon: Shield,
      content: `TITANIA es una plataforma web de gestión empresarial que ofrece las siguientes funcionalidades:

• Gestión de relaciones con proveedores
• Administración de gastos empresariales
• Control y registro de compras
• Gestión de comprobantes de pago
• Integración con WhatsApp para procesos específicos (registro de comprobantes, aprobación de documentos, notificaciones)

La plataforma permite a empresas registrarse como usuarios suscriptores y otorgar acceso a múltiples usuarios dentro de su organización para interactuar con los datos empresariales.`
    },
    {
      id: 'registro',
      title: '3. Registro y Cuenta de Usuario',
      icon: Users,
      content: `3.1. Registro: Para utilizar TITANIA, su empresa debe registrarse como usuario suscriptor proporcionando información precisa, completa y actualizada.

3.2. Responsabilidad: Usted es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades realizadas bajo su cuenta.

3.3. Usuarios Adicionales: Como suscriptor principal, puede otorgar acceso a otros usuarios de su empresa. Usted es responsable de las acciones de todos los usuarios asociados a su cuenta.

3.4. Información Veraz: Se compromete a proporcionar información verdadera y mantenerla actualizada. TITANIA se reserva el derecho de suspender cuentas con información falsa o fraudulenta.`
    },
    {
      id: 'suscripcion',
      title: '4. Suscripciones y Pagos',
      icon: CreditCard,
      content: `4.1. Planes: TITANIA ofrece planes de suscripción mensuales y anuales.

4.2. Renovación: Las suscripciones son renovables. La renovación puede ser automática según la modalidad seleccionada.

4.3. Falta de Renovación: Si una suscripción no se renueva:
   • Se pierde el acceso para ingresar nueva información
   • Durante 3 meses posteriores al vencimiento, podrá consultar los datos históricos en modo de solo lectura
   • Después de 3 meses sin renovación, se bloqueará completamente el acceso a los datos de la empresa

4.4. Precios: Los precios están sujetos a cambios con notificación previa de 30 días.

4.5. Reembolsos: Los pagos son no reembolsables excepto en los casos expresamente indicados en nuestra política de reembolsos o requeridos por ley.`
    },
    {
      id: 'uso',
      title: '5. Uso Aceptable',
      icon: AlertCircle,
      content: `Usted se compromete a:

5.1. Utilizar el servicio únicamente para fines legales y comerciales legítimos.

5.2. No intentar acceder de manera no autorizada a sistemas, datos o redes.

5.3. No utilizar el servicio para transmitir virus, malware o código malicioso.

5.4. No realizar ingeniería inversa, descompilar o intentar extraer el código fuente.

5.5. No revender, sublicenciar o transferir su acceso sin autorización expresa.

5.6. Cumplir con todas las leyes aplicables en su jurisdicción.`
    },
    {
      id: 'whatsapp',
      title: '6. Integración con WhatsApp',
      icon: MessageSquare,
      content: `6.1. Funcionalidad: TITANIA ofrece integración con WhatsApp para facilitar procesos como registro de comprobantes, aprobación de documentos y notificaciones.

6.2. Consentimiento: Al utilizar estas funcionalidades, usted consiente el uso de WhatsApp como canal de comunicación con la plataforma.

6.3. Disponibilidad: La funcionalidad de WhatsApp depende de servicios de terceros. TITANIA no garantiza disponibilidad continua de esta integración.

6.4. Seguridad: Debe mantener seguro el acceso a su dispositivo y cuenta de WhatsApp, ya que se utilizará para autenticar acciones en la plataforma.`
    },
    {
      id: 'datos',
      title: '7. Protección de Datos',
      icon: Lock,
      content: `7.1. Propiedad: Usted conserva la propiedad de todos los datos que ingresa en TITANIA.

7.2. Privacidad: Nos comprometemos a proteger sus datos conforme a nuestra Política de Privacidad y las leyes aplicables de protección de datos.

7.3. Respaldo: TITANIA realiza respaldos periódicos, pero recomienda que mantenga sus propias copias de información crítica.

7.4. Retención: Después del vencimiento de su suscripción, conservaremos sus datos por 3 meses. Transcurrido este período, los datos podrán ser eliminados permanentemente.

7.5. Seguridad: Implementamos medidas técnicas y organizativas para proteger sus datos, pero no podemos garantizar seguridad absoluta.`
    },
    {
      id: 'disponibilidad',
      title: '8. Disponibilidad del Servicio',
      icon: Calendar,
      content: `8.1. Esfuerzo Comercial: TITANIA hará esfuerzos razonables para mantener la disponibilidad del servicio, pero no garantiza operación ininterrumpida.

8.2. Mantenimiento: Podemos realizar mantenimientos programados con notificación previa cuando sea posible.

8.3. Sin Garantía: El servicio se proporciona "tal cual" sin garantías de ningún tipo, expresas o implícitas.`
    },
    {
      id: 'limitacion',
      title: '9. Limitación de Responsabilidad',
      icon: Shield,
      content: `9.1. TITANIA no será responsable por:
   • Pérdida de datos, ganancias o beneficios
   • Daños indirectos, incidentales o consecuentes
   • Interrupciones del servicio
   • Acciones de terceros
   • Fuerza mayor

9.2. Límite Máximo: En caso de responsabilidad comprobada, esta no excederá el monto pagado por el suscriptor en los últimos 12 meses.`
    },
    {
      id: 'modificaciones',
      title: '10. Modificaciones',
      icon: FileText,
      content: `10.1. Términos: TITANIA se reserva el derecho de modificar estos términos en cualquier momento. Los cambios significativos serán notificados con 30 días de anticipación.

10.2. Servicio: Podemos modificar, suspender o discontinuar cualquier aspecto del servicio con notificación previa.

10.3. Continuidad: El uso continuado del servicio después de las modificaciones constituye aceptación de los nuevos términos.`
    },
    {
      id: 'terminacion',
      title: '11. Terminación',
      icon: AlertCircle,
      content: `11.1. Por el Usuario: Puede cancelar su suscripción en cualquier momento desde su panel de control.

11.2. Por TITANIA: Podemos suspender o terminar su acceso por:
   • Violación de estos términos
   • Falta de pago
   • Conducta fraudulenta o ilegal
   • Inactividad prolongada

11.3. Efectos: Al terminar, perderá acceso inmediato para ingresar nuevos datos, con período de gracia de consulta según lo estipulado en la sección de suscripciones.`
    },
    {
      id: 'general',
      title: '12. Disposiciones Generales',
      icon: FileText,
      content: `12.1. Acuerdo Completo: Estos términos constituyen el acuerdo completo entre las partes.

12.2. Divisibilidad: Si alguna disposición es inválida, las demás permanecerán en vigor.

12.3. Jurisdicción: Estos términos se rigen por las leyes de [Jurisdicción Aplicable].

12.4. Notificaciones: Las notificaciones se realizarán al correo electrónico registrado.

12.5. Cesión: No puede ceder sus derechos sin nuestro consentimiento previo por escrito.`
    },
    {
      id: 'contacto',
      title: '13. Contacto',
      icon: MessageSquare,
      content: `Para preguntas sobre estos Términos de Servicio, puede contactarnos en:

Email: contacto@neotec.pe
Teléfono: +51 1 3633864
Sitio web: https://www.neotec.pe

Última actualización: Noviembre 2025`
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border border-indigo-100">
          <div className="flex items-center gap-4 mb-4">
            <div className="bg-gradient-to-br from-indigo-600 to-blue-600 p-3 rounded-xl">
              <FileText className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Términos de Servicio</h1>
              <p className="text-indigo-600 font-semibold text-lg">Titania by Neotec</p>
            </div>
          </div>
          <p className="text-gray-600 leading-relaxed">
            Por favor, lea atentamente estos Términos de Servicio antes de utilizar nuestra plataforma.
            Al acceder o utilizar TITANIA, usted acepta estar legalmente vinculado por estos términos.
          </p>
          <div className="mt-4 bg-indigo-50 border border-indigo-200 rounded-lg p-4">
            <p className="text-sm text-indigo-900 font-medium">
              Última actualización: Noviembre 2025
            </p>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {sections.map((section) => {
            const Icon = section.icon;
            const isActive = activeSection === section.id;

            return (
              <div
                key={section.id}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => setActiveSection(isActive ? null : section.id)}
                  className="w-full px-6 py-5 flex items-center gap-4 hover:bg-gray-50 transition-colors"
                >
                  <div className={`p-2 rounded-lg transition-colors ${isActive
                    ? 'bg-indigo-600 text-white'
                    : 'bg-indigo-100 text-indigo-600'
                    }`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <h2 className="text-lg font-semibold text-gray-900 text-left flex-1">
                    {section.title}
                  </h2>
                  <div className={`transform transition-transform ${isActive ? 'rotate-180' : ''
                    }`}>
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </button>

                {isActive && (
                  <div className="px-6 pb-6 pt-2">
                    <div className="prose prose-sm max-w-none">
                      <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                        {section.content}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="mt-8 bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl shadow-xl p-8 text-white">
          <h3 className="text-xl font-bold mb-3">¿Tiene preguntas?</h3>
          <p className="mb-4 text-indigo-100">
            Si tiene alguna pregunta sobre estos Términos de Servicio, no dude en contactarnos.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="mailto:contacto@neotec.pe" className="bg-white text-indigo-600 px-6 py-2 rounded-lg font-semibold hover:bg-indigo-50 transition-colors">
              Contactar Soporte
            </a>
            <a href="/privacy" className="bg-indigo-700 px-6 py-2 rounded-lg font-semibold hover:bg-indigo-800 transition-colors">
              Ver Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};